/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryResult } from './categoryResult';
import { ParentTextNote } from './parentTextNote';
import { SourceEnum } from './sourceEnum';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface MultipleChildResult { 
    categoryResults: Array<CategoryResult>;
    /**
     * Child's age in time, when result was finished
     */
    childAge: string;
    childUuid?: string;
    /**
     * If send with child_uuid, child_uuid is ignored. One of them is required.
     */
    actorUuid?: string;
    dataSetUuid: string;
    percent: number;
    /**
     * In ISO 8601 format with timezone
     */
    finishedAt: Date;
    /**
     * Maximum score in source
     */
    maxScore: string;
    /**
     * Score that the child earned
     */
    score: string;
    /**
     * Where the result came from, i.e. test, questionnaire, ...  * `dad_test` - Dad Test * `dad_test_z` - Dad Test Z * `questionnaire` - Questionnaire * `game` - Game * `smart` - Smart * `pap_questionnaire` - Pap Questionnaire
     */
    source: SourceEnum;
    /**
     * UUID of specific source, i.e. specific test (e.g. preschool diagnostic), specific questionnaire, ...
     */
    sourceUuid: string;
    /**
     * Psychological categories, which are locked for user with his current license type.
     */
    lockedCategories?: Array<string>;
    visibleToTeacher: boolean;
    textNotesForParent: Array<ParentTextNote>;
}